import Route from '@ember/routing/route';

import type DesignerController from 'webapp/controllers/designer';

export default class DesignerBoardIndexRoute extends Route {
	override setupController(): void {
		const designerController = this.controllerFor('designer') as DesignerController,
			boardState = designerController.boardState;
		if (boardState) {
			boardState.selectBlock(null);
		}
	}
}
